export default __webpack_public_path__ + "static/icon-medication-peach-15662860ee7cb6576d0df9789fb0e6b3.png";